import axios from 'axios'
import { core } from '@/config/pluginInit'
import { getFacilityId } from '@/Utils/facility'
import router from './router/index'
export default () => {
  const facilityId = getFacilityId()
  const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      Authorization: `Bearer ${
        localStorage.getItem('userToken')
          ? localStorage.getItem('userToken')
          : null
      }`,
      Accept: 'application/json',
      ...(facilityId ? { facility_id: facilityId } : {})
    }
  })
  apiClient.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      if (!error.response) {
        core.showSnackbar('error', 'Network error. Please check your connection.')
        return Promise.reject(error)
      }
      const { status, data } = error.response
      if (status === 401 || (data && data.message === 'Unauthenticated')) {
        localStorage.removeItem('userToken')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('formStep')
        localStorage.removeItem('permissions')
        router.push('/business')
      }
      if (data && data.errors) {
        for (const [key, value] of Object.entries(data.errors)) {
          core.showSnackbar('error', value)
        }
      } else if (data && data.message) {
        core.showSnackbar('error', data.message)
      }
      return Promise.reject(error)
    }
  )
  return apiClient
}
